import get from 'lodash/get';

import { getSmarDocumentContent } from 'common/api/sunpal/interactiveProposal';

import {
    FETCH_SMART_DOCUMENT_CONTENT,
    FETCH_SMART_DOCUMENT_CONTENT_FAILURE,
    FETCH_SMART_DOCUMENT_CONTENT_SUCCESS,
} from '../actionTypes';
import { interactiveProposalPreviewActions } from '../reducer';

export default (id, initTemplate) => (dispatch) =>
    new Promise((resolve) => {
        dispatch(
            interactiveProposalPreviewActions[FETCH_SMART_DOCUMENT_CONTENT](),
        );

        getSmarDocumentContent(id)
            .then((response) => {
                const data = get(response, 'data', {});
                dispatch(
                    interactiveProposalPreviewActions[
                        FETCH_SMART_DOCUMENT_CONTENT_SUCCESS
                    ](data),
                );
                const documentContent = get(data, 'content_str', '{}');
                initTemplate(JSON.parse(documentContent));
            })
            .catch((error) =>
                dispatch(
                    interactiveProposalPreviewActions[
                        FETCH_SMART_DOCUMENT_CONTENT_FAILURE
                    ](error?.response?.data?.errors),
                ),
            )
            .finally(resolve);
    });
